/**
 * Formata o CEP usando os seguintes critérios:
 * - `'00000-000'` para CEP (8 Digitos);
 * - Caso inválido retorna o próprio parâmetro `cep`.
 *
 * @param cep CEP a ser formatado
 * @returns Valor com a máscara aplicada
 *   ou o próprio parâmetro  `cep` caso seja inválido
 */
export function formatarCEP(cep: string) {
  const cepAux = cep.replace(/\D/g, '');

  if (cepAux.length === 8) {
    return cepAux.replace(/(\d{5})(\d{3})/, '$1-$2');
  } else {
    return cep;
  }
}
